export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}
